<app-modal-actionable iconSrc="assets/ico/briefcase.svg" title="Custom field" color="dark-blue" [data]="data"
    dataIconSrc="assets/ico/briefcase.svg">
    <div icon class="modal-icon icon fill-white" aria-label="custom-fields" [inlineSVG]="'assets/ico/briefcase.svg'"></div>

    <div content>
        <apc-action-card>
            <apc-save-back-action-buttons buttons></apc-save-back-action-buttons>
            <div content class="fullwidth">
                <div class="container-fluid">
                    <div class="row">
                        <div class="form-group col-lg-4">
                            <label>Tipologia</label>
                            <select class="form-control">
                                <option>Generic</option>
                            </select>
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Data inizio validità</label>
                            <input class="form-control" type="text" />
                        </div>
                        <div class="form-group col-lg-3">
                            <label>Data fine validità</label>
                            <input class="form-control" type="text" />
                        </div>
                        <div class="form-group col-lg-2 bell-icon">
                            <apc-ui-switch>
                                <span label>
                                    <div class="icon" aria-label="bell"
                                        [inlineSVG]="'assets/ico/notifications_active.svg'"></div>
                                </span>
                            </apc-ui-switch>
                        </div>
                        <div class="form-group col-lg-4 mt-3">
                            <label>Valore</label>
                            <input class="form-control" type="text" />
                        </div>
                        <div class="form-group col-lg-12 mt-4">
                            <label>Descrizione</label>
                            <textarea class="form-control" type="text" placeholder="Descrizione generica…"
                                rows="6"></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </apc-action-card>
    </div>

</app-modal-actionable>